import script from "./AddEditDog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditDog.vue?vue&type=script&setup=true&lang=js"

import "./AddEditDog.vue?vue&type=style&index=0&id=25639b6a&scoped=true&lang=scss"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25639b6a"]])

export default __exports__